// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ButtonWithDialog_dialog__2paao"};